import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Kan mitt serveringstillstånd återkallas?";
const SHORT_ANSWER = "Ja. Vid allvarliga eller upprepade överträdelser kan kommunen återkalla tillståndet enligt 9 kap. alkohollagen.";

export const Route = createFileRoute("/fraga/kan-mitt-tillstand-aterkallas")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Kan mitt serveringstillstånd återkallas" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Återkallelse föregås normalt av erinran eller varning, men allvarliga händelser (våld, ungdomsservering, ekobrott) kan leda direkt till återkallelse. Beslutet går att överklaga till förvaltningsrätten."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Alkohollagen kap. 8 – servering" }}
      related={[{"to": "/fraga/vad-skiljer-erinran-fran-varning", "label": "Vad är skillnaden mellan erinran och varning?"}, {"to": "/fraga/vad-ar-kunskapsprovet", "label": "Vad är kunskapsprovet i alkohollagen?"}, {"to": "/fraga/vad-ar-pbi-kretsen", "label": "Vad är PBI-kretsen?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Kan mitt serveringstillstånd återkallas?" },
      { name: "description", content: "Ja. Vid allvarliga eller upprepade överträdelser kan kommunen återkalla tillståndet enligt 9 kap. alkohollagen." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/kan-mitt-tillstand-aterkallas" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/kan-mitt-tillstand-aterkallas" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/kan-mitt-tillstand-aterkallas",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Kan mitt serveringstillstånd återkallas", url: "https://alkoholprovet.se/fraga/kan-mitt-tillstand-aterkallas" },
      ]),
    ],
  }),
});
